import { attr } from '@ember-data/model';
import ShModel from './sh-model';

const TITLE_TEXT = {
  EARNINGS_YTD: 'Earnings YTD',
  PAID_YTD: 'Paid out YTD',
  UPCOMING_PAYOUTS: 'Pending payouts',
};

const TYPES = {
  SELF: 'self',
};

export const FACTOID = {
  TITLE_TEXT,
  TYPES,
};

const Factoid = ShModel.extend({
  type: attr('string'),
  title: attr('string'),
  subTitle: attr('string'),
  fact: attr('string'),
  factUnit: attr('string'),
});

export default Factoid;
